import React, { useState } from "react"
import { Col, Container, Row, FormGroup, Label, Form, Input } from "reactstrap"
import { Link } from "react-router-dom"
import axios from "axios"

const APIserver = "https://hdform.herokuapp.com/api/facility/add"

const AddFacilityForm = () => {
  const [name, setName] = useState("")
  const [mobile, setMobile] = useState("")
  const [address, setAddress] = useState("")
  const [email, setEmail] = useState("")

  const submitRegistration = (e) => {
    e.preventDefault()
    const newFacility = {
      name,
      email,
      mobile,
      address,
    }

    axios
      .post(APIserver, newFacility)
      .then((res) => console.log(res.data.message))
      .then((res) => alert(JSON.stringify(res.data)))
      .catch((err) => console.log(JSON.stringify(err)))
      .finally((res) => setTimeout(window.location.replace("/admin"), 700))
    console.log(newFacility)
  }

  return (
    <Container className="registration-form">
      <Container className="text-center">
        <h1>Register your facility or business</h1>
      </Container>
      <Form className="form-top-padding" onSubmit={submitRegistration}>
        <FormGroup>
          <Label>Facility Name</Label>
          <Input
            type="text"
            placeholder="Business / Place / Facility name"
            onChange={(e) => setName(e.target.value)}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label>Mobile No.</Label>
          <Input
            type="tel"
            placeholder="Ex 09171234567"
            required
            minLength="11"
            maxLength="11"
            onChange={(e) => setMobile(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleState">Email Address</Label>
          <Input
            type="email"
            required
            placeholder="youremail@yourdomain.com"
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Address</Label>
          <Input
            type="text"
            name="address"
            placeholder="House or Building No / Street / Barangay"
            required
            onChange={(e) => setAddress(e.target.value)}
          />
        </FormGroup>
        <Row>
          <Col md="2">
            <Input type="submit" className="btn btn-primary" value="Submit" />
          </Col>
          <Col md="2">
            <Link to="/admin">
              <Input type="button" className="btn btn-secondary" value="Back" />
            </Link>
          </Col>
        </Row>
      </Form>
    </Container>
  )
}

export default AddFacilityForm
